export default "__VITE_ASSET__Cpm3n_eb__"